import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from "../lib/api";

const usePageViews = () => {
    const location = useLocation();
    const lastPathNameRef = useRef(null);

    const postPageView = async (path, title) => {
        try {
            const response = await api.post(`page-view`, { endpoint: path, title: title });
        } catch (err) {
            console.error('Error updating page view', err)
        }
    }

    const handlePageView = () => {
        const title = document.title; 
        postPageView(location.pathname, title);
    }

    useEffect(() => {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if(mutation.type === 'childList' && mutation.target.nodeName === 'TITLE') {
                    const currentPathName = location.pathname;
                    if (lastPathNameRef.current !== currentPathName) {
                        handlePageView(); 
                        lastPathNameRef.current = currentPathName;
                    }
                }
            })
        })

        const config = { childList: true, subtree: true };
        const targetNode = document.querySelector('title');
        if (targetNode) {
            observer.observe(targetNode.parentNode, config)
        }

        return () => observer.disconnect();
    }, [location])
}

export default usePageViews;